import React from 'react';
import TabContextProvider from '../Common/Form/Tab/TabContext';
import TabNav from '../Common/Form/Tab/TabNav';
import TabContent from '../Common/Form/Tab/TabContent';
import PersonalInformationForm from './PersonalInformationForm';
import YourPreferencesForm from './YourPreferencesForm';
import EmailAndPasswordForm from './EmailAndPasswordForm';
import UserContextProvider from './UserContext';

const Profile = () => {
    return (
        <div className="-shadow tabs" id="tabs-top">
            <TabContextProvider>
                <TabNav>
                    <span>
                        Personal
                        <br />
                        Information
                    </span>
                    <span>
                        Your
                        <br />
                        Preferences
                    </span>
                    <span>
                        Change Email
                        <br />
                        and Password
                    </span>
                </TabNav>
                <UserContextProvider>
                    <TabContent>
                        <PersonalInformationForm />
                        <YourPreferencesForm />
                        <EmailAndPasswordForm />
                    </TabContent>
                </UserContextProvider>
            </TabContextProvider>
        </div>
    );
};

Profile.propTypes = {};

export default Profile;
